import Backbone from 'backbone'
import $ from 'jquery'
import renderValuesSelect from 'scoreboard/datasets/filters/render-values-select'
import rangeSelectMultiple from 'scoreboard/datasets/filters/range-select-multiple'
import renderYesNoSelect from 'scoreboard/datasets/filters/render-yes-no-select'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

const InlineTagInput = Backbone.View.extend({

	className: 'inline-tag-input',

	/**
	 * @constructs tag-based input for editing text filter values
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.filter - the filter to be used for editing. Will
	 * not be mutated
	 *
	 * @param {Object} options.field - the dataset field used in the filter
	 *
	 * @param {Array} [options.suggestions] a list of values to use as "suggestions"
	 * in the filtering select
	 *
	 * @param {Dataset} options.model
	 *
	 * @param {Boolean} [options.includeBlank=true] Decides if the blank option
	 * should be included when rendering a Yes/No select
	 */
	initialize(options = {}) {
		this.options = options
		this.filter = options.filter
		this.field = options.field
		this.includeBlank = options.includeBlank ?? true
	},

	render: function () {
		let initial = this.filter.values || []
		let input = $(`<select name="values">`)
			.on('change', () => {
				// See 'blur' event handler for explanation of what's
				// going on with this.justChanged
				this.justChanged = true

				this.trigger('change')

				process.nextTick(() => this.justChanged = false)
			})

		this.$el.append(input)

		let ranges = this.field.ranges
		if (this.filter.operator == 'in-the-range') {
			rangeSelectMultiple(input, ranges, this.filter.rangeIds, { open: true })
		} else if (this.field.dataType === YES_NO) {
			renderYesNoSelect(input, {
				selected: this.filter.values,
				open: true,
				includeBlank: this.includeBlank
			})
		} else {
			renderValuesSelect({
				dataset: this.model,
				fieldId: this.field.id,
				dataType: this.field.dataType,
				el: input,
				operator: this.filter.operator,
				values: initial,
				suggestions: this.options.suggestions,
				selectOptions: { open: true }
			})
		}

		this.$('textarea')
			.on('blur', () => {
				if (this.justChanged) {
					// The 'blur' event on the textarea fires when a user clicks
					// on a tag to delete it. So we set this.justChanged=true
					// on 'change', then the 'blur' event fires, and we can skip
					// triggering 'done'. Then on nextTick, we set
					// this.justChanged=false, so that when the user actually
					// blurs from the input, we can trigger 'done'
					return
				}

				this.trigger('done')
			})
			.focus()

		this.$el
			.width(this.$el.width()) // Have to set a fixed width so SCSS can transition correctly
			.addClass('is-expanded')

		// After the width has expanded, we need to set the select's height value to
		// 'auto' so it can expand to fit its contents.
		// 300 matches the value of `$animation-dataset-filter-widget-transition-speed`
		// set in animations.scss
		setTimeout(() => { this.$('.select').css('height', 'auto') }, 300)
		return this
	},

	val: function () {
		return this.$('select').val()
	}
})

export default InlineTagInput

InlineTagInput.__filename__ = 'dashboards/widgets/dataset-filter/inline-tag-input.js'
